import React, { useState } from "react";
import { TERMS_DATA } from "../../utils/termsData";
import BreadCrumb from "../../components/BreadCrumb";

const AccordionSection = ({ title, isOpen, onClick, children }) => (
  <div className="border rounded-lg mb-4 shadow-sm">
    <button
      onClick={onClick}
      className="w-full px-6 py-4 flex justify-between items-center bg-gray-50 hover:bg-gray-100 rounded-t-lg transition-colors duration-200"
    >
      <span className="text-lg font-semibold text-gray-800">{title}</span>
      <span className="text-2xl text-gray-600 transform transition-transform duration-200">
        {isOpen ? "−" : "+"}
      </span>
    </button>
    {isOpen && (
      <div className="p-6 border-t bg-white rounded-b-lg">{children}</div>
    )}
  </div>
);

const TermsAndCondition = () => {
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (index) => {
    setOpenSections((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div className="max-w-5xl mx-auto p-6 px-4 sm:px-0">
      <BreadCrumb
        title="Terms & Condition"
        desc="Last Updated: February 2025"
      />

      <div className="space-y-4 mt-10">
        {TERMS_DATA.map((term, index) => (
          <AccordionSection
            key={index}
            title={term.title}
            isOpen={openSections[index]}
            onClick={() => toggleSection(index)}
          >
            <div className="space-y-4">
              {term.sections.map((section, sectionIndex) => (
                <div key={sectionIndex} className="space-y-2">
                  <p className="text-[#888888] font-semibold text-[#888888]">{section.title}</p>

                  {section.list && section.list.length > 0 && (
                    <ul className="list-disc pl-6 space-y-2">
                      {section.list.map((item, itemIndex) => (
                        <li key={itemIndex} className="text-gray-600">
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </AccordionSection>
        ))}
      </div>

      <div className="mt-8 p-4 bg-gray-50 rounded-lg text-center text-gray-600 font-semibold sm:text-[18px] text-[14px] flex flex-col gap-3">
       <h2>For support, contact: <a href="mailto:product@upgrowthmarketing.in" className="text-[#7B3BCC] underline">product@upgrowthmarketing.in</a></h2> 
      <h2>By using Money Rate Finder, you agree to these Terms and Conditions.</h2>
      </div>
    </div>
  );
};

export default TermsAndCondition;
